import { Icon } from '@ridi/rsg';
import classNames from 'classnames';
import { createElement } from 'react';

var SelectBox = function (props) {
    var title = props.title, className = props.className, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.renderOutline, renderOutline = _b === void 0 ? false : _b, onChange = props.onChange, children = props.children, value = props.value;
    return (createElement("div", { className: classNames([
            'RUISelectBox',
            renderOutline && 'RUISelectBox-outline',
            className,
        ]) },
        createElement("select", { title: title, className: "RUISelectBox_Select", disabled: disabled, onChange: onChange, value: value }, children),
        createElement(Icon, { className: "RUISelectBox_Icon", name: "arrow_1_down" })));
};

export { SelectBox };
//# sourceMappingURL=SelectBox.js.map



// WEBPACK FOOTER //
// /static/node_modules/@ridi/rsg/components/dist/SelectBox.js